import { React, useEffect, useRef, useState } from "react";
// import { addProject, apiFormValidation, editProject, getMunicForm, getProjectInfo } from "../../utils/apiUtils";
import './ActionForm.css';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import ContactSection from "./ContactSection";
import { useDispatch, useSelector } from "react-redux";
import SuccessFormSection from "./SuccessFormSection";
import { useNavigate } from "react-router-dom";
import AlertPopup from "../../components/AlertPopup/AlertPopup";
import { extractKeyName, stepsDic } from "../../utils/externalFunc";
import ActivitySection from "./ActivitySection";
import {
    clearFormValsForAnotherActivity,
    setFormActiveStep,
    setFormVals,
    setStandbyPlaceId,
    updateContactMemoryObj
} from "../../store/YamatReducer";
import { getOrganizationForm, sendFromFinal } from "../../utils/apiUtils";



export default function ActionForm(props){
    
    const store = useSelector(state => state.reducer)
    const [formPageData, setFormPageData] = useState(false)
    const [formLoader, setFormLoader] = useState(false)
    const [steps, setSteps] = useState(["מה תרצו לעשות?", "פרטי איש קשר"])
    const [activeStep, setActiveStep] = useState(store.activeStep)
    const [sectionsArray, setSectionsArray] = useState(["ActivitySection_form", "ContactSection_form"])
    const [formValidation, setFormValidation] = useState({ActivitySection_form: "start", ContactSection_form: "start"})
    const [errorsObjReady, setErrorsObjReady] = useState({})
    const [errorModalShow, setErrorModalShow] = useState(false)
    const [errorModalText, setErrorModalText] = useState(false)
    //const [loadProjectAlertModalShow, setLoadProjectAlertModalShow] = useState(false)
    const [formValsLocal, setFormValsLocal] = useState(store.formVals)
    //const [activityFormSection, setActivityFormSection] = useState(false)
    const [successMsg, setSuccessMsg] = useState("")
    const [formLoad, setFormLoad] = useState(false)
    const [getFormloader, setGetFormloader] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [firstStepTitle, setFirstStepTitle] = useState("")
    const switches = ["IsWallPainting", "IsRenewalPainting", "IsGardening"]

    const getForm = async () => {
        setGetFormloader(true)
        getOrganizationForm(store.formVals.ProjectDetails.FieldId).then(res => {
            setFormPageData(res.data)
            setFirstStepTitle(res.data.Title)
        })
        .catch(error => {
            console.log(error)
        }).finally(x => setGetFormloader(false))
    }

    const handleNext = () => {
        activeStep < stepsDic.SuccessFormSection && checkStep()
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }

    let finalMount = useRef(true);
    useEffect(() => {
        if (finalMount.current) {
            finalMount.current = false;
            if(store.formVals.ProjectDetails.FieldId !== 0){
                getForm()
                setFormLoad(true)
            }else{
                navigate("/")
            }
        }
    }, [])

    useEffect(() => {
        formLoad && getForm()
      }, [store.formVals.ProjectDetails.FieldId])

    // Transform old API structure to new API structure
    const transformToNewApiStructure = (oldData) => {
        const { ProjectDetails, Contact, Place } = oldData;
        const logistics = ProjectDetails?.ProjectLogistics || {};

        // Helper function to map color names (old format to new format)
        const mapColor = (colorInput) => {
            if (!colorInput) return null;

            // Map Hebrew/old color names to English lowercase
            const colorMap = {
                'אדום': 'red',
                'כחול': 'blue',
                'ירוק': 'green',
                'צהוב': 'yellow',
                'כתום': 'orange',
                'סגול': 'purple',
                'אפור': 'grey',
                'שחור': 'black',
                'לבן': 'white',
                'בז\'': 'beige',
                'חום': 'brown',
                'red': 'red',
                'blue': 'blue',
                'green': 'green',
                'yellow': 'yellow',
                'orange': 'orange',
                'purple': 'purple',
                'grey': 'grey',
                'black': 'black',
                'white': 'white',
                'beige': 'beige',
                'brown': 'brown'
            };

            // Handle if colorInput is a string
            if (typeof colorInput === 'string') {
                return [colorMap[colorInput] || 'grey'];
            }

            // Handle if colorInput is an array
            if (Array.isArray(colorInput)) {
                if (colorInput.length === 0) return null;
                return colorInput.map(c => colorMap[c] || 'grey');
            }

            return null;
        };

        // Build logistics object
        const buildLogistics = () => {
            const logisticsObj = {};

            // Helper to check if a value is meaningful (not 0, empty string, or empty array)
            const hasValue = (val) => {
                if (val === null || val === undefined) return false;
                if (typeof val === 'number') return val > 0;
                if (typeof val === 'string') return val.trim() !== '';
                if (Array.isArray(val)) return val.length > 0;
                return false;
            };

            // Walls - from IsWallPainting or IsRenewalPainting
            if (logistics.IsWallPainting || logistics.IsRenewalPainting) {
                const height = parseFloat(logistics.WallpaintHeight) || 0;
                const width = parseFloat(logistics.WallpaintWidth) || 0;
                const totalSqm = parseFloat(logistics.WallSqmTotal) || 0;
                const sizeInSqm = (height && width) ? height * width : totalSqm;

                if (sizeInSqm > 0 || hasValue(logistics.WallRenewColour) || hasValue(logistics.WallRenewColours)) {
                    logisticsObj.walls = {
                        sizeInSqm: sizeInSqm,
                        color: mapColor(logistics.WallRenewColour || logistics.WallRenewColours)?.[0] || 'white'
                    };
                }
            }

            // Windows
            if (hasValue(logistics.WindowsNum) || hasValue(logistics.WindowColours)) {
                logisticsObj.windows = {
                    total: parseInt(logistics.WindowsNum) || 0,
                    color: mapColor(logistics.WindowColours)?.[0] || 'white',
                    hasRust: false
                };
            }

            // Doors
            if (hasValue(logistics.DoorsNum) || hasValue(logistics.DoorsColours) || hasValue(logistics.DoorsMaterialIds)) {
                logisticsObj.doors = {
                    total: parseInt(logistics.DoorsNum) || 0,
                    color: mapColor(logistics.DoorsColours)?.[0] || 'white',
                    hasRust: false
                };
            }

            // Bars (from Grates)
            if (hasValue(logistics.GratesAreaSqm) || hasValue(logistics.GratesColours)) {
                logisticsObj.bars = {
                    length: parseFloat(logistics.GratesAreaSqm) || 0,
                    color: mapColor(logistics.GratesColours)?.[0] || 'grey',
                    hasRust: false
                };
            }

            // Handrails (from Railing)
            if (hasValue(logistics.RailingLength) || hasValue(logistics.RailingColours)) {
                logisticsObj.handrails = {
                    length: parseFloat(logistics.RailingLength) || 0,
                    color: mapColor(logistics.RailingColours)?.[0] || 'grey',
                    hasRust: false
                };
            }

            // Garden
            if (logistics.IsGardening || hasValue(logistics.GardeningAreaSqm) || hasValue(logistics.GardeningIds)) {
                logisticsObj.garden = {
                    sizeInSqm: parseFloat(logistics.GardeningAreaSqm) || 0,
                    totalPlanters: 0,
                    plantFlowers: Array.isArray(logistics.GardeningIds) && logistics.GardeningIds.includes("plantFlowers"),
                    plantSpices: Array.isArray(logistics.GardeningIds) && logistics.GardeningIds.includes("plantSpices")
                };
            }

            // Yard Facility (from Facilities)
            if (hasValue(logistics.FacilitiesNum) || hasValue(logistics.FacilitiesColours)) {
                logisticsObj.yardFacility = {
                    total: parseInt(logistics.FacilitiesNum) || 0,
                    colors: mapColor(logistics.FacilitiesColours) || []
                };
            }

            // Fence
            if (hasValue(logistics.FenceLength) || hasValue(logistics.FenceColours)) {
                logisticsObj.fence = {
                    length: parseFloat(logistics.FenceLength) || 0,
                    colors: mapColor(logistics.FenceColours) || []
                };
            }

            // Add hasEquipment flag (could be derived from other data)
            logisticsObj.hasEquipment = false;

            // Add notes if FormComment exists
            if (hasValue(ProjectDetails.FormComment)) {
                logisticsObj.notes = ProjectDetails.FormComment ? [{text: ProjectDetails.FormComment, createdAt: new Date()}] : []
            }

            return Object.keys(logisticsObj).length > 0 ? logisticsObj : undefined;
        };

        // Build address string
        const buildAddress = () => {
            const parts = [
                Place.Street,
                Place.HouseNum
            ].filter(Boolean);
            return parts.join(', ') || 'כתובת לא צוינה';
        };

        // Map FieldId to activity field
        const getActivityField = (fieldId, activityFieldOverride) => {
            // If activityField is explicitly set (for FieldId 10), use it
            if (activityFieldOverride) {
                return activityFieldOverride;
            }

            const fieldMap = {
                '1': 'PackingFoodDonationGear', // אריזה וחלוקת מזון וציוד לתרומה
                '2': 'TransportEquipmentMedicinesPatients', // שינוע ציוד, תרופות וחולים
                '3': 'FacilitationInstruction', // הפעלה והדרכה
                '4': 'Environment', // איכות הסביבה
                '6': 'Animals', // בעלי חיים
                '10': 'GardeningPainting', // גינון וצביעה
                '15': 'Other' // אחר
            };
            return fieldMap[String(fieldId)] || 'Other';
        };

        // Build the new structure
        const newStructure = {
            project: {
                name: Place.OrganizationName || 'פרויקט חדש',
                numericalId: 0, // This might need to come from somewhere else
                address: {
                    address: buildAddress(),
                    city: Place.CityID?.toString() || '0' // This should be MongoDB ObjectId
                },
                description: ProjectDetails.Description || '',
                status: 'external',
                assignmentStatus: 'noVolunteers',
                budget: {
                    details: [],
                    approved: 0,
                    notes: []
                },
                year: new Date().getFullYear(),
                source: 'Amotot',
                type: 'OneTime',
                notes: ProjectDetails.FormComment ? [{text: ProjectDetails.FormComment, createdAt: new Date()}] : [],
                attributes: {
                    timeOfDay: [], // Could be derived from FromTime
                    placeOfVolunteering: Place.PlaceDescription || '',
                    activityField: getActivityField(ProjectDetails.FieldId, ProjectDetails.activityField),
                    projectValues: '',
                    numVolunteersGuests: 0,
                    canPublishOnWebsite: undefined,
                    suitableForBusiness: true,
                    suitableForPR: undefined,
                    hasSecurityClearance: false,
                    isMissingInformation: true,
                    hasReceivedEquipment: undefined,
                    accessibleForDisabled: undefined,
                    hasExternalOrganization: false,
                    projectOpenToPublic: true,
                    organizationDetails: {
                        externalName: Place.OrganizationName,
                        externalBrandName: Place.Branch
                    }
                },
                hidden: false
            },
            shift: {
                startTime: ProjectDetails.FromTime || '09:00',
                endTime: ProjectDetails.ToTime || '18:00',
                availablePlaces: (ProjectDetails.MaxVolunteersPerShift && parseInt(ProjectDetails.MaxVolunteersPerShift)) || parseInt(ProjectDetails.VolunteersNum) || 40,
                numOfPlaces: parseInt(ProjectDetails.VolunteersNum) || 40
            },
            contact: {
                contact: {
                    name: `${Contact.FirstName || ''} ${Contact.LastName || ''}`.trim() || 'ללא שם',
                    email: Contact.Email || '',
                    phone: Contact.Phone || '',
                    newsletter: Place.IsNewsLetter || true,
                },
                isPrimary: true
            }
        };

        // Add logistics if they exist
        const projectLogistics = buildLogistics();
        if (projectLogistics) {
            newStructure.project.logistics = projectLogistics;
        }
        return newStructure;
    };

    const sendForm = () => {
        // if validation ok, send form or step up
        if(activeStep + 1 === stepsDic.SuccessFormSection){
            setFormLoader(true)
            let jsonToSend = store.formVals
            // Clean up accordion fields that are not enabled before sending
            if(store.formVals?.ProjectDetails?.ProjectLogistics && store.switchArrayKeys){
                switches.map(item => {
                    if(!store.formVals.ProjectDetails.ProjectLogistics[item]){
                        if(store.switchArrayKeys[item]){
                            store.switchArrayKeys[item].map(key => {
                                let value = (key.includes("GardeningIds") || key.includes("FacilitiesColours") || key.includes("FenceColours")) ? [] : 0
                                let pathArray = key.split(".")
                                jsonToSend = {...jsonToSend, [pathArray[0]]: { ...jsonToSend[pathArray[0]], [pathArray[1]]: {...jsonToSend[pathArray[0]][pathArray[1]], [pathArray[2]]: value}}}
                                updateFormValues(value, key)
                            })
                        }
                    }
                })
            }

            // Transform to new API structure
            const transformedJson = transformToNewApiStructure(jsonToSend);
            sendFromFinal(transformedJson).then(res => {
                if(res.status === 200 || res.status === 201){
                    setSuccessMsg('הטופס נשלח בהצלחה')
                    //res.data?.guid_id && dispatch(setStandbyPlaceId(res.data.guid_id))
                    setActiveStep(stepsDic.SuccessFormSection)
                    dispatch(clearFormValsForAnotherActivity())
                }else{
                    setErrorModalText("שגיאה בשמירת הטופס")
                    setErrorModalShow(true)
                }
            }).catch(error => {
                setErrorModalText("שגיאה בשמירת הטופס")
                setErrorModalShow(true)
            }).finally(() => setFormLoader(false))
        }else{
            setActiveStep((prevActiveStep) => prevActiveStep + 1)
        }
    }

    // Bootstrap validation function - validates only fields that exist in the current form
    const bootstrapFormValidation = (formStepInfo) => {
        const errors = [];
        const formData = store.formVals;

        // Error messages for each field
        const errorMessages = {
            // ProjectDetails
            "VolunteersNum": "יש למלא כמות המתנדבים הדרושה",
            "Description": "יש למלא תיאור פרויקט",
            "FromTime": "יש למלא משעה",
            "ToTime": "יש למלא עד שעה",
            "MaxVolunteersPerShift": "יש למלא מספר המתנדבים המירבי שיוכלו להגיע בכל משמרת",
            "ActivityOrganizer": "יש למלא מי יארגן את הפעילות",
            "WallpaintHeight": "ציורי קיר : יש למלא גובה ורוחב קיר",
            "WallpaintWidth": "ציורי קיר : יש למלא גובה ורוחב קיר",
            // Contact
            "LastName": "יש למלא שם משפחה",
            "FirstName": "יש למלא שם פרטי",
            "Phone": "יש למלא מספר טלפון",
            "Position": "יש למלא תפקיד",
            "Email": "יש למלא אימייל",
            // Place
            "CityID": "יש לבחור יישוב",
            "PopulationID": "יש לבחור למי אתם עוזרים",
            "OrganizationName": "יש להזין שם עמותה",
            "PlaceDescription": "יש למלא תיאור מקום",
            "Street": "יש להזין כתובת"
        };

        // Validate fields based on form step info
        if (formStepInfo) {
            const fieldsToValidate = [];

            // Extract all required fields from form step info
            if (Array.isArray(formStepInfo)) {
                formStepInfo.forEach(step => {
                    if (step.FormFields) {
                        step.FormFields.forEach(field => {
                            // Skip FormFieldID 77 (Position field - removed from UI)
                            // Skip FormFieldID 48 (removed from UI)
                            if (field.IsRequired && field.FormFieldID !== 77 && field.FormFieldID !== 48) {
                                try {
                                    // Parse FormFieldDetails JSON string
                                    const fieldDetails = JSON.parse(field.FormFieldDetails);
                                    if (fieldDetails.object_path) {
                                        fieldsToValidate.push({
                                            name: fieldDetails.identifier,
                                            path: fieldDetails.object_path,
                                            title: field.Title
                                        });
                                    }
                                } catch (e) {
                                    // Skip fields with invalid JSON
                                }
                            }
                        });
                    }
                });
            } else if (formStepInfo.FormFields) {
                formStepInfo.FormFields.forEach(field => {
                    // Skip FormFieldID 77 (Position field - removed from UI)
                    // Skip FormFieldID 48 (removed from UI)
                    if (field.IsRequired && field.FormFieldID !== 77 && field.FormFieldID !== 48) {
                        try {
                            // Parse FormFieldDetails JSON string
                            const fieldDetails = JSON.parse(field.FormFieldDetails);
                            if (fieldDetails.object_path) {
                                fieldsToValidate.push({
                                    name: fieldDetails.identifier,
                                    path: fieldDetails.object_path,
                                    title: field.Title
                                });
                            }
                        } catch (e) {
                            // Skip fields with invalid JSON
                        }
                    }
                });
            }

            // Add conditional required fields (based on switches/accordions)
            // Check if wall painting is enabled
            if (formData.ProjectDetails?.ProjectLogistics?.IsWallPainting) {
                fieldsToValidate.push({
                    name: 'WallpaintHeight',
                    path: 'ProjectDetails.ProjectLogistics.WallpaintHeight',
                    title: 'גובה קיר'
                });
                fieldsToValidate.push({
                    name: 'WallpaintWidth',
                    path: 'ProjectDetails.ProjectLogistics.WallpaintWidth',
                    title: 'רוחב קיר'
                });
            }

            // Check if renewal painting is enabled
            if (formData.ProjectDetails?.ProjectLogistics?.IsRenewalPainting) {
                // Add any renewal painting required fields here if needed
            }

            // Check if gardening is enabled
            if (formData.ProjectDetails?.ProjectLogistics?.IsGardening) {
                // Add any gardening required fields here if needed
            }

            // Add FieldId-specific required fields
            // FieldId 3 requires activity organizer and participant details
            if (formData.ProjectDetails?.FieldId === 3) {
                fieldsToValidate.push({
                    name: 'ActivityOrganizer',
                    path: 'ProjectDetails.ActivityOrganizer',
                    title: 'מי יארגן את הפעילות'
                });
                fieldsToValidate.push({
                    name: 'ActivityParticipantsNum',
                    path: 'ProjectDetails.ActivityParticipantsNum',
                    title: 'מספר המופעלים'
                });
                fieldsToValidate.push({
                    name: 'ParticipantsAge',
                    path: 'ProjectDetails.ParticipantsAge',
                    title: 'גילאי המופעלים'
                });
                fieldsToValidate.push({
                    name: 'ParticipantsDescription',
                    path: 'ProjectDetails.ParticipantsDescription',
                    title: 'מאפיינים מיוחדים של המפעילים'
                });
            }

            // Validate each required field
            fieldsToValidate.forEach(field => {
                const pathParts = field.path.split('.');
                let value = formData;
                for (const part of pathParts) {
                    value = value?.[part];
                }

                // Check if value is empty
                // Check if it's an ID field by looking at the path (e.g., Place.CityID)
                const isIdField = field.path.includes('ID') || field.path.includes('Id');
                const isEmpty = value === null || value === undefined || value === "" ||
                               (typeof value === 'string' && value.trim() === "") ||
                               (isIdField && value === 0);

                if (isEmpty) {
                    const fieldKey = field.path.split('.').pop();
                    errors.push({
                        Key: `organizationProject.${field.path}`,
                        Value: [errorMessages[fieldKey] || `יש למלא ${field.title}`]
                    });
                } else {
                    // Additional validation for specific field types
                    // Phone number validation (Israeli phone numbers)
                    if (field.path === 'Contact.Phone') {
                        const phonePattern = /^0(5[0-9]|[2-4]|[8-9])[0-9]{7}$/;
                        if (!phonePattern.test(value)) {
                            errors.push({
                                Key: `organizationProject.${field.path}`,
                                Value: ['מספר טלפון לא תקין']
                            });
                        }
                    }

                    // Email validation
                    if (field.path === 'Contact.Email') {
                        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (!emailPattern.test(value)) {
                            errors.push({
                                Key: `organizationProject.${field.path}`,
                                Value: ['כתובת אימייל לא תקינה']
                            });
                        }
                    }
                }
            });
        }

        return errors;
    }

    const checkStep = () => {
        let errors = [];

        // Get the appropriate form step info based on active step
        if (activeStep === stepsDic.ActivitySection_form && formPageData) {
            // Activity Section - validate based on formPageData.FormSteps
            errors = bootstrapFormValidation(formPageData.FormSteps);
        } else if (activeStep === stepsDic.ContactSection_form && props.topSectionForm) {
            // Contact Section - validate based on the second step (index 1) which contains contact fields
            // topSectionForm.FormSteps[0] = "מה תרצו לעשות?" (already filled)
            // topSectionForm.FormSteps[1] = "פרטי איש קשר" (contact section)
            const contactStep = props.topSectionForm.FormSteps?.[1];
            if (contactStep) {
                errors = bootstrapFormValidation([contactStep]);
            }
        }

        const isValid = manageErrors(errors);

        if (isValid && (activeStep + 1) < 3) {
            sendForm();
        }

        setTimeout(function (){
            let el = document.querySelector('.is-invalid, [aria-invalid="true"]');
            el && el.focus();
        },400)
    }

    const manageErrors = (errArray) => {
        let errors = {}
        if(errArray){
            if(errArray.length > 0){
                errArray.map(item => {
                    let key = item.Key.split(".")
                    key = key.length > 0 ? key[key.length -1] : key
                    errors[key] = item.Value[0]
                })
            }
        }
        // Clean up errors for accordion fields that are not enabled
        if(store.formVals?.ProjectDetails?.ProjectLogistics && store.switchArrayKeys){
            switches.map(item => {
                if(!store.formVals.ProjectDetails.ProjectLogistics[item]){
                    if(store.switchArrayKeys[item]){
                        store.switchArrayKeys[item].map(key => {
                            let keyName = extractKeyName(key)
                            delete errors[keyName]
                        })
                    }
                }
            })
        }
        setErrorsObjReady(errors)
        return Object.keys(errors).length === 0
    }

    useEffect(() => {
        dispatch(setFormActiveStep(activeStep))
    }, [activeStep])

    useEffect(() => {
        dispatch(setFormVals({...formValsLocal}))
    }, [formValsLocal])

    const updateFormValues = (value, path) => {
        let pathArray = path.split(".")
        let key = pathArray[pathArray.length - 1]
        setErrorsObjReady({...errorsObjReady, [key]: null})
        if(typeof(pathArray) !== "undefined" && pathArray.length > 0){
            if(pathArray.length === 2){
                let newFormVals = {...store.formVals, [pathArray[0]]: { ...store.formVals[pathArray[0]], [pathArray[1]]: value}}
                dispatch(setFormVals(newFormVals))
                if(key === "Email" || key === "Position" || key === "Phone" || key === "FirstName" || key === "LastName" ){
                    dispatch(updateContactMemoryObj({key: `Contact.${key}`, value: value}))
                }
                if(key === "Branch" || key === "OrganizationName"){
                    dispatch(updateContactMemoryObj({key: `Place.${key}`, value: value}))
                }
            }else if(pathArray.length === 3){
                dispatch(setFormVals({...store.formVals, [pathArray[0]]: { ...store.formVals[pathArray[0]], [pathArray[1]]: {...store.formVals[pathArray[0]][pathArray[1]], [pathArray[2]]: value}}}))
            }
        }
    }

    return  <div className="container-fluid ActionForm align-items-center d-flex flex-column min-height-100">
                <h1 className="text-center primary_color f-bold mt-4 mb-2 mt-md-4 mb-md-4 pt-2">{props.mainPageDataObj.Title}</h1>
                
                    <div className="mx-3 mt-2 py-5 bg-body w-100 d-flex flex-column align-items-center">
                        {activeStep < 2 && <div className="stepper_con" aria-hidden="true">
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps?.map((label, index) => (
                                <Step key={index}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                                ))}
                            </Stepper>
                        </div>}
                        {activeStep == 0 && <span className={'sr-only'}>שלב ראשון מתוך 2 מה תרצו לעשות</span>}
                        {activeStep == 1 && <span className={'sr-only'}>שלב שני מתוך 2 מה תרצו לעשות</span>}

                        {activeStep === stepsDic.ActivitySection_form && formPageData && 
                        <ActivitySection
                            updateFormValsFromMemoryObject={props.updateFormValsFromMemoryObject}
                            errorsObjReady={errorsObjReady} 
                            validation={formValidation[sectionsArray[activeStep]]} 
                            updateFormValues={updateFormValues} 
                            stepInfo={formPageData.FormSteps} 
                            activityFormSection={props.topSectionForm}
                            firstStepTitle={firstStepTitle}
                            getFormloader={getFormloader}
                        />}
                        {activeStep === stepsDic.ContactSection_form && formPageData && props.topSectionForm && 
                        <ContactSection 
                            errorsObjReady={errorsObjReady} 
                            validation={formValidation[sectionsArray[activeStep]]} 
                            updateFormValues={updateFormValues} 
                            stepInfo={props.topSectionForm}
                        />}
                        {activeStep === stepsDic.SuccessFormSection && formPageData && <SuccessFormSection successMsg={successMsg} updateFormValues={updateFormValues}/>}

                    </div>
                        
                        {activeStep < stepsDic.SuccessFormSection && <div className="d-flex justify-content-center py-5">
                            <button color="inherit" disabled={activeStep === stepsDic.ActivitySection_form} onClick={handleBack} className="btn-primary btn ms-0 me-1 f-bold">הקודם</button>
                            <button onClick={handleNext} className="btn-primary btn f-bold">
                                {/* last stage -> PartnerSection */}
                                {activeStep === stepsDic.PartnerSection_form ? 'נצא לדרך' : 'הבא'}
                                {formLoader && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                            </button>
                            <AlertPopup textLine1={errorModalText} textLine2="" setModalShow={setErrorModalShow} modalShow={errorModalShow} tryAgainFunc={handleNext}/>
                            {/* <AlertPopup textLine1={`ארעה תקלה בטעינת הפרויקט`} textLine2={`שורה שניה לבחירה`} setModalShow={setLoadProjectAlertModalShow} modalShow={loadProjectAlertModalShow} tryAgainFunc={false}/> */}
                        </div>} 
                            
            </div>
}